import PropTypes from 'prop-types';
import { useMemo, useState, useEffect } from 'react';
import { CssBaseline } from '@mui/material';
import {
   ThemeProvider as MUIThemeProvider,
   createTheme,
   StyledEngineProvider,
} from '@mui/material/styles';
import Palette from './palette';

export default function ThemeProvider({ children }) {
   // Use useState for theme mode
   const [currentTheme, setCurrentTheme] = useState('light');
   
   // Load theme from localStorage on mount
   useEffect(() => {
      try {
         const savedTheme = localStorage.getItem('themeMode');
         if (savedTheme && (savedTheme === 'light' || savedTheme === 'dark')) {
            setCurrentTheme(savedTheme);
         }
      } catch (error) {
         console.error('Error reading theme from localStorage:', error);
      }
   }, []);
   
   const themeCol = useMemo(() => Palette(currentTheme, 'default'), [currentTheme]);
   
   const themeOptions = useMemo(
      () => ({
         palette: themeCol.palette,
         breakpoints: {
            values: {
              xs: 0,
              sm: 600,
              md: 900,
              lg: 1200,
              xl: 1536,
              wide: 1800,
              xxl: 1920,
              ultra: 2560,
            },
          },
         components: {
            MuiButton: {
               styleOverrides: {
                  root: {
                     textTransform: 'none',
                  },
                  contained: {
                     '&:disabled': {
                        ...(currentTheme === 'dark' && {
                           backgroundColor: 'rgba(255, 255, 255, 0.08)',
                           color: 'rgba(255, 255, 255, 0.3)',
                        }),
                     },
                  },
               },
            },
         },
      }),
      [themeCol]
   );

   const theme = createTheme(themeOptions);

   return (
      <StyledEngineProvider injectFirst>
         <MUIThemeProvider theme={theme}>
            <CssBaseline />
            {children}
         </MUIThemeProvider>
      </StyledEngineProvider>
   );
}

ThemeProvider.propTypes = {
   children: PropTypes.node,
};
